import {orderDeliveryMethodChanged} from './../redux/draft/draftOrderSlice'
import {deliveryTypes} from 'app/constant'
import * as yup from 'yup'

type DraftOrderItem = {
  id?: string
  product: any
  productId: string
  variantId: string
  variant: string
  quantity: number
  price: number
  discountPrice: number
  totalPrice: number
  available: number
  dirtyField: boolean
  shipAvailableForAdminPortal: number
  pickupAvailableForAdminPortal: number
}

export default DraftOrderItem

export const DraftOrderItemSchema = yup.object({
  variantId: yup.string().required('Please select a product'),
  quantity: yup
    .number()
    .test({
      name: 'available',
      exclusive: true,
      message: 'Inventory not available',
      test: function (value: any) {
        const {parent, createError, from}: any = this
        const pickupAvailableForAdminPortal = parent.pickupAvailableForAdminPortal
        const shipAvailableForAdminPortal = parent.shipAvailableForAdminPortal
        const orderDeliveryMethod = from[1]?.value?.orderDeliveryMethod
        if (orderDeliveryMethod === deliveryTypes.ship && shipAvailableForAdminPortal < value) {
          return createError({path: 'quantity', message: 'Inventory not available for shipping'})
        } else if (
          orderDeliveryMethod === deliveryTypes.pickup &&
          pickupAvailableForAdminPortal < value
        ) {
          return createError({path: 'quantity', message: 'Inventory not available for pickup'})
        }

        return true
      },
    })

    .min(1, 'Quantity must be greater than or equal to 1')
    .typeError('Quantity must be greater than or equal to 1')
    .required('Please enter a quantity'),
})
